export enum BoutiqueActionTypes {
  LOAD_BOUTIQUES = "LOAD_BOUTIQUES",
  LOAD_BOUTIQUES_ERROR = "LOAD_BOUTIQUES_ERROR",
  SET_BOUTIQUES = "SET_BOUTIQUES",
  CHANGE_BOUTIQUE = "CHANGE_BOUTIQUE",
  UPDATE_SELECTED_BOUTIQUE = "UPDATE_SELECTED_BOUTIQUE",
  CREATE_BOUTIQUE = "CREATE_BOUTIQUE",
  CREATE_BOUTIQUE_SUCCESS = "CREATE_BOUTIQUE_SUCCESS",
  CREATE_BOUTIQUE_ERROR = "CREATE_BOUTIQUE_ERROR",
  UPDATE_BOUTIQUE = "UPDATE_BOUTIQUE",
  UPDATE_BOUTIQUE_SUCCESS = "UPDATE_BOUTIQUE_SUCCESS",
  UPDATE_BOUTIQUE_ERROR = "UPDATE_BOUTIQUE_ERROR",
  DELETE_BOUTIQUE = "DELETE_BOUTIQUE",
  DELETE_BOUTIQUE_SUCCESS = "DELETE_BOUTIQUE_SUCCESS",
  DELETE_BOUTIQUE_ERROR = "DELETE_BOUTIQUE_ERROR",
}
